module.exports = __webpack_public_path__ + "images/lp-sl-m-lauren-newbould-1-mobile.webp";